import styled from 'styled-components';
import Colors from 'library/constants/colors';
import { ButtonFileContainer, ButtonFile } from 'library/components/item/styles';
import { Content as ModalContent, Container as ModalContainer } from '../styles';

export const Container = styled(ModalContainer)`
  ${ButtonFileContainer} {
    margin-left: -40px;
    margin-right: -40px;
    margin-bottom: 32px;
    padding-bottom: 32px;
    padding-left: 40px;
    padding-right: 40px;
    background: ${Colors.shade07};
  }
  
  ${ButtonFile} {
     margin-bottom: 0;
  }
`;

export const Content = styled(ModalContent)`
  padding-top: 0;
`;

export const SliderContainer = styled.div`
  padding-top: 1px;
  padding-bottom: 8px;
  background: ${Colors.shade07};
  
  &:empty {
    padding-top: 30px;
  }

  .slick-slider {
    .slick-track > div {
      display: inline-block;
    }
  }
  .slick-list {
    padding: 32px 0;
    overflow-x: hidden;
  }
`;
